// OwnershipCertificate/table.config.ts
import { TFunction } from 'i18next'
import { Checkbox } from 'antd'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { CheckboxMapping, ColumnType, Locale, CertificateOwnership } from '../types'
import { isChecked, toggleCheckbox } from './helpers'
import { Import } from '../../../assets/icons'
import { ImportButton } from '../components'
import style from '../style.m.less'
import { FC, SetStateAction } from 'react'

export const getTableColumns = (
    t: TFunction,
    logoCheckboxMappings: CheckboxMapping[],
    isGradientCheckboxMappings: CheckboxMapping[],
    setLogoCheckboxMappings: (value: SetStateAction<CheckboxMapping[]>) => void,
    setIsGradientCheckboxMappings: (value: SetStateAction<CheckboxMapping[]>) => void,
    handleDownloadClick: (record: CertificateOwnership, locale: Locale) => Promise<void>,
): Array<ColumnType> => [
    {
        title: () => (
            <div style={{ textAlign: 'center' }}>{t('ownershipCertificate.certTable.GOName')}</div>
        ),
        width: 250,
        dataIndex: 'go_name',
        key: 'go_name',
        align: 'left',
    },
    {
        title: () => (
            <div style={{ textAlign: 'center' }}>
                {t('ownershipCertificate.certTable.certificateNumber')}
            </div>
        ),
        width: 150,
        dataIndex: 'number',
        key: 'number',
        align: 'left',
    },
    {
        title: () => (
            <div style={{ textAlign: 'center' }}>
                {t('ownershipCertificate.certTable.generationPeriod')}
            </div>
        ),
        width: 150,
        dataIndex: 'period',
        key: 'period',
        align: 'left',
    },
    {
        title: () => (
            <div style={{ textAlign: 'center' }}>
                {t('ownershipCertificate.certTable.generationVolume')}
            </div>
        ),
        width: 150,
        dataIndex: 'volume',
        key: 'volume',
        align: 'right',
    },
    {
        title: () => (
            <div style={{ textAlign: 'center' }}>
                {t('ownershipCertificate.certTable.certificateIsGradient')}
            </div>
        ),
        key: 'certificate_is_gradient',
        width: 80,
        align: 'center',
        render: (record: CertificateOwnership) => (
            <CheckboxCell
                checked={isChecked(isGradientCheckboxMappings, record.id)}
                onChange={(e: CheckboxChangeEvent) =>
                    toggleCheckbox(setIsGradientCheckboxMappings, record, e.target.checked)
                }
                disabled={!record.company_id}
            />
        ),
    },
    {
        title: () => (
            <div style={{ textAlign: 'center' }}>
                {t('ownershipCertificate.certTable.certificateLogo')}
            </div>
        ),
        key: 'certificate_logo',
        width: 80,
        align: 'center',
        render: (record: CertificateOwnership) => (
            <CheckboxCell
                checked={isChecked(logoCheckboxMappings, record.id)}
                onChange={(e: CheckboxChangeEvent) =>
                    toggleCheckbox(setLogoCheckboxMappings, record, e.target.checked)
                }
                disabled={!record.company_id}
            />
        ),
    },
    {
        title: '',
        key: 'download_ru',
        width: 60,
        align: 'right',
        render: (record: CertificateOwnership) => (
            <DownloadCell locale="ru" onClick={() => handleDownloadClick(record, 'ru')} />
        ),
    },
    {
        title: '',
        key: 'download_en',
        width: 60,
        align: 'right',
        render: (record: CertificateOwnership) => (
            <DownloadCell locale="en" onClick={() => handleDownloadClick(record, 'en')} />
        ),
    },
]

const CheckboxCell: React.FC<{
    checked: boolean
    onChange: (e: CheckboxChangeEvent) => void
    disabled: boolean
}> = ({ checked, onChange, disabled }) => (
    <div
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        style={{ display: 'flex', justifyContent: 'center' }}
    >
        <Checkbox
            checked={checked}
            onChange={onChange}
            style={{ width: 25, height: 25 }}
            disabled={disabled}
        />
    </div>
)

const DownloadCell: FC<{
    locale: 'ru' | 'en'
    onClick: () => Promise<void>
}> = ({ locale, onClick }) => (
    <div
        className={style.importWrap}
        onClick={async (e) => {
            e.stopPropagation()
            await onClick()
        }}
    >
        <ImportButton value="" icon={<Import />} customIconStyle={{ marginTop: '3px' }} />
        <span>{locale === 'ru' ? 'ru' : 'eng'}</span>
    </div>
)

export const TABLE_CONSTANTS = {
    PAGE_SIZE: 10,
    DEFAULT_PAGINATION: {
        page: 1,
        pageSize: 10,
        filters: {},
        total: 0,
    },
} as const
